import React, { memo } from "react";
import { Box, Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

interface WireInstructionBackButtonProps {
  onClick: () => void;
  label?: string;
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingBottom: "0 !important",
    marginBottom: theme.spacing(-4),
    [theme.breakpoints.down("lg")]: {
      marginBottom: theme.spacing(-3),
    },
  },
  backLink: {
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: theme.spacing(1, 2),
    margin: theme.spacing(-1, -2),
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.primary.main,
    transition: "color .15s",
    "&:hover": {
      color: theme.palette.info.main,
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: 16,
      padding: theme.spacing(1, 1.5),
      margin: theme.spacing(-1, -1.5),
    },
  },
}));

export const WireInstructionBackButton = memo(({ onClick, label = "← Back" }: WireInstructionBackButtonProps) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.wrapper}>
      <Box
        component="button"
        className={classes.backLink}
        onClick={onClick}
        data-testid="wire-form-back-button"
        role="button"
        tabIndex={0}
      >
        {label}
      </Box>
    </Grid>
  );
});

WireInstructionBackButton.displayName = "WireInstructionBackButton";
